<template>
  <v-container fluid class="px-0">
    <v-row class="my-10">
      <AppTitleComponent :title="'Mis postulaciones'" />
    </v-row>
    <ChatComponent />
    <v-row class="mt-12 ml-3 mr-3 d-flex justify-center" dense>
      <v-col cols="12" sm="12" md="4" lg="3" class="px-0">
        
        <AppFiltro
          :nombre-ruta="'mi-postulaciones'"
          :instituciones="instituciones"
          :establecimientos="establecimientos"
          :areas-interes="areasInteres"
          :estado-postulacion="estadoPostulacion"
          @actualizar-filtro="onActualizarFiltro" @limpiar-filtro="onLimpiarFiltro" />
      </v-col>
      <!-- Sección cards postulaciones -->
      <v-col cols="12" sm="12" md="8" lg="9" class="px-0">
        <v-row class="d-flex justify-center">
          <v-col v-for="(postulacion) in ListPostulaciones" :key="postulacion.id" cols="12">
            <CardPostulacion :item="postulacion" @on-click-detalle="detallesEmpleo"
              @on-click-favorito="gestionarFavorito" @on-click-proceso="procesoPostulacion" />
          </v-col>
        </v-row>
        <v-row v-if="ListPostulaciones.length !== 0">
          <v-col cols="12">
            <div class="text-center">
              <AppPaginationPlus v-model="page" :total-pages="totalPages > 0 ? totalPages : 1"
                @change="getListPostulaciones" @perPageChange="changePerPage" :selectorPerPage="false" />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="(!ListPostulaciones || ListPostulaciones.length === 0) && !busquedaExitosa"
        class="d-flex flex-column justify-center align-center pt-8">
        <v-img :style="`width:${widthImgEmpty};`" src="../../assets/img/emptyConvocatoria.png">
        </v-img>
        <h1 class="text-grey text-center text-h5 font-weight-black text-empty" style="margin-top: -50px; z-index: 1;">
          No tienes postulaciones <br v-if="$vuetify.breakpoint.smAndUp">
          disponibles por el momento</h1>
      </v-col>
    </v-row>

    <app-loader v-if="loading"></app-loader>
  </v-container>
</template>
<script>
import CardEmpleo from '../../components/CardEmpleo.vue'
import ChatComponent from "../../components/ChatComponent.vue";
import AppLoader from "@/components/AppLoader.vue";
import CardPostulacion from './components/CardPostulacion.vue';
import { mapMutations, mapState } from "vuex";
export default {
  name: 'MisPostulaciones',
  components: {
    AppLoader,
    CardEmpleo,
    ChatComponent,
    CardPostulacion
  },
  data() {
    return {
      ListPostulaciones: [],
      loading: false,
      message: '',
      windowWidth: window.innerWidth,
      page: 1,
      per_page: 8,
      pagination: false,
      totalRegistros: null,
      instituciones: [],
      establecimientos: [],
      areasInteres: [],
      estadoPostulacion: [],
      search: {
        fecha_inicio_postulacion: null,
        fecha_fin_postulacion: null,
        id_area_interes: null,
        id_institucion: null,
        id_establecimiento: null,
        id_estado_postulacion: null
      },
      busquedaExitosa: false
    }
  },
  methods: {
    async changePerPage(per_page) {
      this.loading = true;
      this.per_page = per_page;
      await this.getListPostulaciones(null);
      this.loading = false;
    },
    detallesEmpleo(id) {
      if (id != null) {
        this.$router.push({ path: `/empleo/${id}`, params: { id_oferta: id } });
      }
    },
    async gestionarFavorito(item) {
      if (this.isTokenValido(this.token)) {
        this.loading = true;
        const body = {
          id_oferta: item,
          id_persona: this.userInfo.id_persona
        };
        try {
          const response = await this.services.favoritos.putFavorito(body);
          if (response.status === 201) {
            this.message = response.data.message
            this.loading = false;
          }
          this.getListPostulaciones(null);
        } catch (e) {
          let errorMessage = "Ocurrió un error";
          if (e.response && e.response.data && e.response.data.err) {
            errorMessage = e.response.data.err.message || e.response.data.err.description;
          }
          this.temporalAlert({
            show: true,
            type: "error",
            message: errorMessage
          });
        } finally {
          setTimeout(() => {
          }, 100);
        }
      } else {
        this.temporalAlert({
          show: true,
          type: "error",
          message: "El token ya expiró, debe de volver a iniciar sesión"
        });
        this.$router.replace({ name: "login" });
      }
    },

    async getListPostulaciones(search) {
      if (this.isTokenValido(this.token)) {
        // if(this.tieneRoles(this.token)) {
        this.loading = true;
        try {
          let params = {
            page: this.page,
            per_page: this.per_page,
            pagination: true,
          }
          if(search){
            params = { ...params, ...search };
          }
          if (typeof this.userInfo.id_persona !== 'undefined') {
            const response = await this.services.postulaciones.getPostulaciones(this.userInfo.id_persona, params)
            // console.log({response})
            if (response.status == 200) {
              this.ListPostulaciones = response?.data?.data;
              this.page = response?.data?.pagination?.page;
              this.per_page = response?.data?.pagination?.per_page;
              this.instituciones = response?.data?.instituciones;
              this.establecimientos = response?.data?.establecimientos;
              this.areasInteres = response?.data?.areas_de_interes;
              this.estadoPostulacion = response?.data?.estados_de_postulacion;
              this.totalRegistros = response?.data?.pagination?.total_rows;
              this.busquedaExitosa = true;
            }
            setTimeout(() => {
              this.loading = false;
            }, 500);
          }
        } catch (e) {

        } finally {

        }
        // } else {
        //   this.temporalAlert({
        //     show:true,
        //     type:"error",
        //     message:"No tiene permiso para listar las postulaciones"
        //   })
        // }

      } else {
        this.temporalAlert({
          show: true,
          type: "error",
          message: "El token ya expiró, debe de volver a iniciar sesión"
        })
        this.$router.replace({ name: "login" })
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },

    procesoPostulacion(id, id_oferta) {
      this.$router.push({ name: 'seguimiento-postulacion', params: { id: id_oferta } });
    },
    onActualizarFiltro(filtro) {
      this.loading = true;
      this.page = 1; // Reiniciar la página al aplicar un filtro
      const rango = filtro.rangoFechasPostulacion
      this.search.fecha_inicio_postulacion = rango.fechaInicio
      this.search.fecha_fin_postulacion = rango.fechaFin
      this.search.id_area_interes = filtro.area_interes
      this.search.id_institucion = filtro.institucion
      this.search.id_establecimiento = filtro.establecimiento
      this.search.id_estado_postulacion = filtro.estado_postulacion
      this.getListPostulaciones(this.search);
      this.loading = false;
    },
    onLimpiarFiltro() {
      this.loading = true;
      this.page = 1; // Reiniciar la página al limpiar el filtro
      this.search.fecha_inicio_postulacion = null
      this.search.fecha_fin_postulacion = null
      this.search.id_area_interes = null
      this.search.id_institucion = null
      this.search.id_establecimiento = null
      this.search.id_estado_postulacion = null
      this.getListPostulaciones(this.search);
      this.loading = false;
    },
  },
  computed: {
    totalPages() {
      // Validar que los valores existan y sean números válidos
      if (!this.totalRegistros || !this.per_page || this.per_page <= 0) {
        return 1; // Valor por defecto válido
      }

      const totalPaginas = Math.ceil(this.totalRegistros / this.per_page);

      // Asegurar que el resultado sea al menos 1
      return Math.max(totalPaginas, 1);
    },
    screenWidth() {
      return this.windowWidth;
    },
    dinamicCols() {
      if (this.screenWidth <= 1905) {
        return 4;
      }
      return 3
    },
    fechaMaxima() {
      return this.$moment().format("YYYY-MM-DD");
    },
    ...mapState(["userInfo", "token"]),
    widthImgEmpty() {
      if (this.$vuetify.breakpoint.xs) {
        return '90%'
      }
      if (this.$vuetify.breakpoint.sm) {
        return '350px'
      }
      if (this.$vuetify.breakpoint.md) {
        return '400px'
      }
      if (this.$vuetify.breakpoint.lg) {
        return '420px'
      }
      if (this.$vuetify.breakpoint.xl) {
        return '500px'
      }
    },
  },
  async created() {
    this.loading = true;
    setTimeout(async () => {
      await this.getListPostulaciones(null)
      this.loading = false;
    }, 1000);




  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }

}

</script>
<style scoped>
/* .postulaciones{
  display: grid;
  grid-template-columns: repeat(4, minmax(200px, 1fr));
  grid-gap: 1rem;
 } */
@media (max-width: 500px) {
  .text-empty {
    font-size: 1em !important;
  }
}

.width_img_empty {
  width: 30%;
}

.text-grey {
  color: #616161;
}
</style>
